import {useMapContext} from '@/components/MindMap/index.mjs'
import MenuButton from '../MenuButton.jsx'
import useMenuItemIntegrate from '../../menuItems/useMenuItemIntegrate.jsx'

export default function MenuButtonIntegrate(props) {
    const map = useMapContext()
    map.useMetaData()

    const items = [
        useMenuItemIntegrate('Sa', '一键集成'),
        useMenuItemIntegrate('RulemRm', '知识模块'),
        useMenuItemIntegrate('Oa', '组织模型'),
        useMenuItemIntegrate('Pa', '知识模型'),
        useMenuItemIntegrate('Fa', '功能模型'),
        useMenuItemIntegrate('Ua', '入口模型'),
        useMenuItemIntegrate('Ls', '接口模型'),
        useMenuItemIntegrate('Ca', '用例模型'),
        useMenuItemIntegrate('Db', '库表模型'),
        useMenuItemIntegrate('Ss', '程序模型'),
    ]

    return (
        <MenuButton
            items={items}
            {...props}
        >
            自动集成
        </MenuButton>
    )
}
